import type { SupUiTheme } from "@/hooks/useTheme";

const config = () => ({
  // prefix used to identify the app in the local storage
  storePrefix: `superform-app-${process.env.VERCEL_GIT_COMMIT_REF}`,
  env: process.env.NEXT_PUBLIC_VERCEL_ENV as string,
  // API params
  api: {
    goAccessToken: process.env.NEXT_APP_API_GO_ACCESS_TOKEN,
    utilsAccessToken: process.env.NEXT_APP_API_UTILS_ACCESS_TOKEN,
    goBaseUrl: process.env.NEXT_APP_API_GO_BASE_URL,
  },
  // 3rd-party services details
  services: {
    spinld: process.env.NEXT_PUBLIC_SF_SERVICE_SPINLD as string,
    mava: process.env.NEXT_PUBLIC_SF_SERVICE_MAVA as string,
    dynamic: process.env.NEXT_APP_SERVICE_DYNAMIC as string,
    vercel: {
      commit_message: process.env.VERCEL_GIT_COMMIT_MESSAGE,
      commit_ref: process.env.VERCEL_GIT_COMMIT_REF,
    },
  },
  tx: {
    cartLimit: parseInt(`${process.env.NEXT_APP_TX_CART_LIMIT}`) || 5,
    withdrawalCartLimit: parseInt(`${process.env.NEXT_APP_TX_WITHDRAWAL_CART_LIMIT}`) || 5,
    avaxCrossChain: Boolean(process.env.NEXT_APP_TX_AVAX_CROSSCHAIN || false),
    limitMultiCrossChain: Boolean(process.env.NEXT_APP_TX_LIMIT_MULTI_CROSSCHAIN || false),
  },
  // Number of decimals to round any fiat value when showing it to the user
  decimalsRoundingLimit: 2,
  // Number of decimals to round APY when showing it to the user
  decimalsApyRoundingLimit: 2,
  // Number of decimals to round any BigInt value when showing it to the user
  decimalsBigRoundingLimit: 6,
  // Minimal amount to deposit into a single vault cross-chain
  minFiatAmount: 20,
  minFiatAmountDeposit: 23,
  // Minimal amount to deposit into a single vault within the same chain
  minFiatAmountSameChain: 1,
  // Default amount of slippage set when depositing / withdrawing
  defaultSlippage: 300,
  localTokens: ["3Crv", "DAI.e", "DAI", "MIM", "MPL", "USDC.e", "USDC", "WAVAX", "WBTC", "WETH", "WPOL", "fUSDT", "oSQTH", "sUSD", "wstETH"],
  alert: {
    enabled: Boolean(process.env.NEXT_APP_SHOW_ALERT || false),
    title: (process.env.NEXT_APP_ALERT_TITLE as string) || "Welcome to Superform App",
    text: process.env.NEXT_APP_ALERT_TXT as string,
  },
  isProd: (process.env.NEXT_PUBLIC_VERCEL_ENV as string) === "production",
  isStaging: (process.env.NEXT_PUBLIC_VERCEL_ENV as string) !== "production",
  privateRPCs: {
    1: process.env.NEXT_PUBLIC_PRIVATE_RPCS_1,
    137: process.env.NEXT_PUBLIC_PRIVATE_RPCS_137,
    42161: process.env.NEXT_PUBLIC_PRIVATE_RPCS_42161,
    10: process.env.NEXT_PUBLIC_PRIVATE_RPCS_10,
    8453: process.env.NEXT_PUBLIC_PRIVATE_RPCS_8453,
    250: process.env.NEXT_PUBLIC_PRIVATE_RPCS_250,
    56: process.env.NEXT_PUBLIC_PRIVATE_RPCS_56,
    43114: process.env.NEXT_PUBLIC_PRIVATE_RPCS_43114,
    81457: process.env.NEXT_PUBLIC_PRIVATE_RPCS_81457,
    59144: process.env.NEXT_PUBLIC_PRIVATE_RPCS_59114,
  } as Record<number, string>,
  defaultTheme: "dark" as SupUiTheme,
  aaveVaultId: process.env.NEXT_PUBLIC_SF_AAVEVAULT_ID,
});
export default config();
